import React from "react";
import DateRangePicker from "rsuite/DateRangePicker";
import { subDays } from "date-fns";
import { DateRange } from "rsuite/esm/DateRangePicker";
import { Typography } from "@mui/material";
import "../date-style.css";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

function isToday(date: Date) {
  const today = new Date();

  if (
    today.getFullYear() === date.getFullYear() &&
    today.getMonth() === date.getMonth() &&
    today.getDate() === date.getDate()
  ) {
    return true;
  }

  return false;
}

export const SelectPeriodButton: React.FC<SelectPeriodModalProps> = (props) => {
  const [value, setValue] = React.useState<DateRange | null>([
    subDays(new Date(), 6),
    new Date(),
  ]);

  const getEndDate = (date: Date) => {
    if (isToday(date)) {
      return date;
    }

    return new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate() + 1,
      0,
      0,
      0,
      0
    );
  };

  return (
    <DateRangePicker
      showOneCalendar
      format="dd.MM.yy"
      placement="auto"
      ranges={[]}
      renderValue={(value) =>
          `${dayjs(value[0]).format("DD.MM")}-${dayjs(value[1]).format("DD.MM")}`
      }
      onChange={(v) => {
        if (v?.[0] === undefined || v?.[1] === undefined) return;

        const startDate = new Date(
          v?.[0].getFullYear(),
          v?.[0].getMonth(),
          v?.[0].getDate(),
          0,
          0,
          0,
          0
        );

        setValue([v?.[0], v?.[1]]);
        props.onPeriodSelected(startDate, getEndDate(v?.[1]));
      }}
      value={value}
      onClean={() => {
        setValue(null);
      }}
      style={{
        borderRadius: "15px",
        borderColor: "transparent",
      }}
      placeholder="Выберите период"
    />
  );

  {
  }
};

export interface SelectPeriodModalProps {
  onPeriodSelected: (start: Date, end: Date) => void;
}